// extracted by mini-css-extract-plugin
module.exports = {"container":"sorting-desktop_container__HiRoK","option":"sorting-desktop_option__2V62v","skeleton-preloader":"sorting-desktop_skeleton-preloader__4VbBC"};